import axios from "../axios/axios";
import {Endpoints} from "../axios/endpoints";
import {v4 as uuid} from "uuid";

const serverPublicKey = "BHEmjl7H1XoCAUBYFRwdE0SJOcAWqHOVNKr17LfgeCoXem7hh8PCor0T-BA3xxzMGHkjikSK9jZjtG6KVF00fjY"

export function askForNotificationPermission() {
    return Notification.requestPermission().then(function (permissionResult) {
        if (permissionResult !== 'granted') {
            throw new Error('We weren\'t granted permission.');
        }

        return permissionResult;
    });
}

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

export function registerServiceWorker() {
    return navigator.serviceWorker.register('/sw-joshirando.js')
        .then(function (registration) {
            console.log('Service worker successfully registered.');
            return registration
        })
        .catch(function (err) {
            console.error('Unable to register service worker.', err);
        });
}

export async function registerPushManager() {
    return navigator.serviceWorker.ready.then(function (registration) {
        const subscribeOptions = {
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(serverPublicKey)
        };
        return registration.pushManager.subscribe(subscribeOptions);
    }).then(function (pushSubscription) {
        axios({
            method: "post",
            url: Endpoints.WEBPUSH,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                subscription: pushSubscription,
                user_agent: navigator.userAgent,
                fingerprint: getFingerprint(),
            },
        }).then(_ => {
        }).catch(_ => {
        })

        return pushSubscription;
    }).catch(err => {
        console.error('Unable to register service worker.', err);
    });
}

export function getFingerprint() {
    let fingerprint = localStorage.getItem("fingerprint")

    if (!fingerprint) {
        fingerprint = uuid();
        localStorage.setItem("fingerprint", fingerprint)
    }

    return fingerprint;
}